import { Injectable } from '@angular/core';
import { ApiService } from '../api/api.service';

@Injectable({
  providedIn: 'root',
})
export class CountryService {
  constructor(private readonly apiService: ApiService) {}

  getAll() {
    return this.apiService.get<any[]>('country');
  }

  getById(id: number | string) {
    return this.apiService.get<any[]>(`country/${id}`);
  }

  update(data: any) {
    return this.apiService.put<any[]>(`country/update`);
  }

  delete(id: number | string) {
    return this.apiService.delete(`country/delete/${id}`);
  }
}
